import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import common from './store/common'
import account from './store/account'
import label from './store/label'
import industry from './store/industry'
import supervise from './store/supervise'
import vendor from './store/vendor'
import product from './store/product'
import certificate from './store/certificate'
import traceinfo from './store/traceinfo'
import batch from './store/batch'
import inspect from './store/inspect'
import delivery from './store/delivery'
import goodsreturn from './store/goodsreturn'
import outstock from './store/outstock'
import vas from './store/vas'
import vacorder from './store/vacorder'
import scantag from './store/scantag'
import stat from './store/stat'
import staff from './store/staff'

import wxaccount from './wx/store/account'
import portal from './wx/store/portal'
import gateway from './wx/store/gateway'
import member from './wx/store/member'
import goods from './wx/store/goods'
import settings from './wx/store/settings'
import integral from './wx/store/integral'
import order from './wx/store/order'
import overview from './wx/store/overview'
import release from './wx/store/release'
import wxapp from './wx/store/wxapp'
import lottery from './wx/store/lottery'
import discount from './wx/store/discount'
import productgroup from './wx/store/productgroup'
import agent from './wx/store/agent'
import coupon from './wx/store/coupon'
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    account,
    label,
    industry,
    supervise,
    vendor,
    product,
    certificate,
    traceinfo,
    batch,
    inspect,
    delivery,
    goodsreturn,
    outstock,
    vas,
    vacorder,
    scantag,
    stat,
    staff,

    wxaccount,
    portal,
    gateway,
    member,
    goods,
    settings,
    integral,
    order,
    overview,
    release,
    wxapp,
    lottery,
    discount,
    productgroup,
    agent,
    coupon
  },
  plugins: process.env.NODE_ENV === 'development' ? [createLogger()] : []
})
